
import { Component, Vue } from "vue-property-decorator";
import moment, { Moment } from "moment";
import appconst from "@/lib/appconst";
import topMsg from "./components/onlineTopMsg.vue";
import { UserModule } from "@/store/modules/user";
import { ChartMessageService, ChartMessageDto } from "@/api/service-proxies";
import PreViewDialog from "./components/previewDialog.vue";
import * as signalR from "@aspnet/signalr";
import { scrollTo } from "@/lib/scroll-to";
@Component({
  components: {
    topMsg,
    PreViewDialog,
  },
})
export default class customIndex extends Vue {
  pageSizeArray = [10, 20, 30, 50, 100];
  pageSizeper = 30;
  currentPage4 = 1;
  total = 0;
  putRequest = {
    studentName: null,
    sorting: undefined,
    skipCount: 0,
    maxResultCount: 10,
  };
  circleUrl =
    "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png";
  textarea = "";
  currrentLoginUser = UserModule.user;
  chartMessageService = new ChartMessageService();
  Loading = false;
  private faceUploading = false;
  chickCurrentUserId = "";
  connection: any;
  ChartListData: any = [];
  mouseX: any;
  mouseY: any;

  menuVisible = false;
  FromMessageInfo = new ChartMessageDto();
  messages: ChartMessageDto[] = [];

  requetId: any = "";
  private faceUploadAction =
    appconst.remoteServiceBaseUrl + "sysadmin/UploadFile/ProductUpload";
  connectemoji = [
    { icon: "😊", id: "emoji1i1" },
    { icon: "😅", id: "emoji2i2" },
    { icon: "😲", id: "emoji3i3" },
    { icon: "😭", id: "emoji4i4" },
    { icon: "😂", id: "emoji5i5" },
    { icon: "😄", id: "emoji6i6" },
    { icon: "😩", id: "emoji7i7" },
    { icon: "😞", id: "emoji8i8" },
    { icon: "😵", id: "emoji9i9" },
    { icon: "😒", id: "emoji10i10" },
    { icon: "😍", id: "emoji11i11" },
    { icon: "😤", id: "emoji12i12" },
    { icon: "😜", id: "emoji13i13" },
    { icon: "😝", id: "emoji14i14" },
    { icon: "😋", id: "emoji15i15" },
    { icon: "😘", id: "emoji16i16" },
    { icon: "😚", id: "emoji17i17" },
    { icon: "😷", id: "emoji18i18" },
    { icon: "😳", id: "emoji19i19" },
    { icon: "😃", id: "emoji20i20" },
    { icon: "😆", id: "emoji21i21" },
    { icon: "😁", id: "emoji22i22" },
    { icon: "😢", id: "emoji23i23" },
    { icon: "😨", id: "emoji24i24" },
    { icon: "😠", id: "emoji25i25" },
    { icon: "😣", id: "emoji26i26" },
    { icon: "😌", id: "emoji27i27" },
    { icon: "😖", id: "emoji28i28" },
    { icon: "😔", id: "emoji29i29" },
    { icon: "😰", id: "emoji30i30" },
    { icon: "😱", id: "emoji31i31" },
    { icon: "😪", id: "emoji32i32" },
    { icon: "😏", id: "emoji33i33" },
    { icon: "😓", id: "emoji34i34" },
  ];
  changeShowListType = 0; //0全部 1当天互动，2当天未答复
  allNumber = {
    totalMessage: 0,
    parentInteraction: 0,
    notAppaly: 0,
  };
  faceTempleteId?: number | null = 0;
  className?: string | null = "";
  created() {
    this.Loading = true;
    this.InitSocket();
    this.getChartList();
  }

  hideMenu() {
    this.menuVisible = false;
  }
  //初始化用户聊天列表ws://localhost:21023/chatHub
  InitSocket() {
    this.connection = new signalR.HubConnectionBuilder()
      .withUrl("wss://api.wkxiaolvsan.com/identity/chatHub", {
        // .withUrl("ws://192.168.3.6/identity/chatHub", {
        skipNegotiation: true,
        transport: signalR.HttpTransportType.WebSockets,
      })
      .build();
    this.connection.start();
    //接收信息
    this.connection.on("SendMessage", (msg) => {
      this.getCharRecord(this.requetId);
      this.getChartList();
    });
    //撤回信息
    this.connection.on("WithDrawMessage", (msg) => {
      this.getCharRecord(this.requetId);
      this.getChartList();
    });
    this.connection.onclose((error) => {
      setTimeout(this.InitSocket, 5000); // 5秒后尝试重连
    });
  }

  pushMessage() {
    this.chartMessageService
      .wxPushToParent(this.FromMessageInfo.currentUserId)
      .then((res) => {
        this.$message.success("推送成功");
      });
  }
  //获取聊天信息列表
  async getChartList() {
    this.putRequest.maxResultCount = this.pageSizeper;
    this.putRequest.skipCount = (this.currentPage4 - 1) * this.pageSizeper;
    await this.chartMessageService
      .getGroupAll(
        this.putRequest.studentName,
        this.changeShowListType,
        this.putRequest.skipCount,
        this.putRequest.maxResultCount
      )
      .then((res) => {
        res.items.forEach(e=>{
        e.faceImg = (this as any).$aes.imgAddAuth(e.faceImg)
      })
        this.ChartListData = res.items;
        this.total = res.totalCount;
        this.allNumber.totalMessage = res.totalMessage;
        this.allNumber.parentInteraction = res.parentInteraction;
        this.allNumber.notAppaly = res.notAppaly;
        if (this.ChartListData.length > 0 && this.chickCurrentUserId == "") {
          this.chickCurrentUserId = this.ChartListData[0].currentUserId;
          this.selectPeople(this.ChartListData[0], 0);
        }
        this.Loading = false;
      });
  }
  // 选择人员颜色改变
  selectPeople(item, index) {
    item.notReadCount = 0;
    this.FromMessageInfo = item;
    this.requetId = item.currentUserId;
    this.chickCurrentUserId = item.currentUserId;
    this.getCharRecord(this.requetId);
  }
  //获取当前用户的聊天记录
  async getCharRecord(currentUserId: string) {
    await this.chartMessageService
      .getCurrentUserMessage(currentUserId)
      .then((res) => {
        res.chartMessageDtos.forEach((e)=>{
          if(e.messageType != 0 ){
            e.content = (this as any).$aes.imgAddAuth(e.content);
          }
        })
        this.messages = res.chartMessageDtos;
        this.className = res.className;
        this.faceTempleteId = res.faceTempleteId;
        this.$nextTick(() => {
          var message = document.getElementById("dlog_content");
          // 滚动滑钮到滚动条顶部的距离=滚动条的高度
          message.scrollTop = message.scrollHeight;
        });
      });
  }

  private onFaceUpladSuccess(response, file, fileList) {
    let isImageOrVideo = 0;
    if (file.raw.type.startsWith("image/")) {
      isImageOrVideo = 1;
    }
    if (file.raw.type.startsWith("video/")) {
      isImageOrVideo = 2;
    }
    this.submitDate(isImageOrVideo, response.result.url);
    this.faceUploading = false;
  }

  private onFaceUploadError(error) {
    this.faceUploading = false;
    this.$message.error("文件上传失败");
  }
  add_biaoqing(item: any) {
    let inputValue = this.textarea;
    inputValue = inputValue + item.icon;
    this.textarea = inputValue;
  }
  handleEnter() {
    this.submitDate(0, this.textarea);
  }
  //撤回消息
  handleCommand(item: number) {
    var obj = {Id:item}
    this.connection.send("WithDrawMessage", obj);
  }

  //发送聊天信息
  submitDate(type, content) {
    var dealContent = content.replace(/(^\s*)|(\s*$)/g, "");
    if (content == "" || dealContent.length == 0) {
      this.$message.warning("不能发送空内容!");
      return;
    }

    var SessionID = this.FromMessageInfo.currentUserId;
    if (SessionID.length < 15) {
      SessionID = this.FromMessageInfo.sessionID;
    }
    var obj = {
      Content: content,
      CurrentUserId: this.FromMessageInfo.currentUserId,
      SessionID: SessionID,
      MessageType: type,
      isShowPop: false,
      studentName: this.FromMessageInfo.studentName,
      relation: this.FromMessageInfo.relation,
      FaceTempleteId: this.FromMessageInfo.faceTempleteId,
      ParentUserId: this.FromMessageInfo.parentUserId,
      tenantId: this.FromMessageInfo.tenantId,
      isTeacherApplay: true,
      replyUserName: this.currrentLoginUser.surname
    };
    // 使用 send 方法发送消息
    try {
      this.connection.send("SendMessage", obj);
      this.textarea = "";
    } catch {
      this.InitSocket();
    }
  }
  handleSizeChange(val) {
    this.pageSizeper = val;
    this.currentPage4 = 1;
    this.getChartList();
    scrollTo(0, 800);
  }
  handleCurrentChange(val) {
    this.currentPage4 = val;
    this.getChartList();
    scrollTo(0, 800);
  }
  // 切换聊天模式
  changeShowList(e) {
    this.changeShowListType = e;
    this.currentPage4 = 1;
    this.getChartList();
  }
  // 搜索人员
  searchPeople() {
    this.currentPage4 = 1;
    this.chickCurrentUserId = "";
    this.getChartList();
  }

  getItemClass(item: ChartMessageDto) {
    if (item.currentUserId != "Chat" + this.currrentLoginUser.id)
      return "cu-item";
    else return "cu-item self";
  }
  getItemHead(item) {
    if (item.isTeacherApplay)
      return "http://file6.wkxiaolvsan.com/files/2nvT1WZ5qhTirbEc0B~zFUALv48JkAAUIuwAFZkqwzXNfiUyjQIouIaKI3JltXIFBfw";
    else if (item.name == "陌生人") return this.circleUrl;
    else return this.FromMessageInfo.faceImg;
  }
  // 打开预览弹框
  openDialog(item, index) {
    (this.$refs.preViewDialogRef as PreViewDialog).open(item, index);
  }
}
